import { useEffect, useRef } from "react";
import Measurement from "@arcgis/core/widgets/Measurement";
import "../../style/layerStyle.css"
import MapView from "@arcgis/core/views/MapView";
import ElevationProfile from "@arcgis/core/widgets/ElevationProfile.js";
import i18next from "i18next";
import { default as distance_cur } from "../../../assets/images/esri/cursors/distance.cur";
import { default as area_cur } from "../../../assets/images/esri/cursors/area.cur";

const MeasuresComponent = ({mapView, mapDiv, clearButton}) => {

    const mapRef = useRef(null);
    const elevationProfRef = useRef(null);

    const addBorder = {
        border: '2px solid #000'
    }

    useEffect(() => {

        const measurement = new Measurement();

        const distanceButton = document.getElementById("distance");
        const areaButton = document.getElementById("area");
        const clearButton = document.getElementById("clear");
        //const switchButton = document.getElementById("switch-btn");

        distanceButton.addEventListener("click", () => {
            distanceMeasurement();
        });
        areaButton.addEventListener("click", () => {
            areaMeasurement();
        });
        clearButton.addEventListener("click", () => {
            clearMeasurements();
        });

        if (mapRef.current.innerHTML !== "") {
            mapRef.current.removeChild(mapRef.current.children[0])
            clearMeasurements();
        }

        let view = new MapView({
            container: mapRef.current,
        })

        view.ui.add(measurement, "bottom-left");
        measurement.view = mapView;

        function distanceMeasurement() {
            //props.mapDiv.current.style.cursor = renderCursor("distance");
            const type = mapView.type;
            measurement.activeTool =
                type.toUpperCase() === "2D" ? "distance" : "direct-line";
            distanceButton.classList.add("active");
            areaButton.classList.remove("active");
        }

        function areaMeasurement() {
            //props.mapDiv.current.style.cursor = renderCursor("area");
            measurement.activeTool = "area";
            distanceButton.classList.remove("active");
            areaButton.classList.add("active");
        }

        function clearMeasurements() {
            distanceButton.classList.remove("active");
            areaButton.classList.remove("active");
            measurement.clear();
        }


        const elevationProfile = new ElevationProfile({
            view: mapView,
            container: elevationProfRef.current,
            profiles: [{
                type: "ground",
                color: "red",
                title: "Perfil Longitudinal"
            }]
        });

    }, [mapView])

    return (
        <>
            <br />
            <div ref={mapRef}></div>
            <div className="esri-component esri-widget">
                <button
                    id="distance"
                    className="esri-widget--button esri-interactive esri-icon-measure-line"
                    title="Distance Measurement Tool"
                />
                <p id="measure-button">{i18next.t('common.tools.measures.distance')}</p>
                <br />
                <button
                    id="area"
                    className="esri-widget--button esri-interactive esri-icon-measure-area"
                    title="Area Measurement Tool"
                />
                <p id="measure-button">{i18next.t('common.tools.measures.area')}</p>
                <br />
                <button
                    ref={clearButton}
                    id="clear"
                    className="esri-widget--button esri-interactive esri-icon-trash"
                    title="Clear Measurements"
                />

                <p id="measure-button">{i18next.t('common.tools.measures.clear')}</p>
            </div>
            <br/>
            <div style={addBorder} ref={elevationProfRef}></div>
        </>
    )
}
export default MeasuresComponent;